import api from '../api/client';

class ContratoService {
  async getConfig(organizadorId) {
    const response = await api.get(`/organizadores/${organizadorId}/contratos/config`);
    return response.data;
  }

  async updateConfig(organizadorId, config) {
    const response = await api.put(`/organizadores/${organizadorId}/contratos/config`, config);
    return response.data;
  }

  gerarContrato1Via(lote, leilao, organizador, config) {
    window.open(`/contratos/uma-via/${lote.id}`, '_blank');
  }

  getContrato1ViaHTML(lote, leilao, organizador, config) {
    const clausulasProcessadas = this.processarClausulas(config.clausulas, lote);
    return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Contrato - Lote ${lote.numero_lote}</title>
<style>${this.getContratoCSS()}</style>
</head>
<body>
<div class="pg">
${this.secCabecalho(organizador, leilao, lote)}
${this.secVendedor(lote)}
${this.secComprador(lote)}
${this.secLote(lote)}
${this.secObservacoes(lote)}
${this.secFinanceiro(lote, config)}
${clausulasProcessadas ? this.secClausulas(clausulasProcessadas) : ''}
${this.secDadosBancarios(lote, organizador, config)}
${this.secAssinaturas(leilao, lote)}
</div>
</body>
</html>`;
  }

  // ─── UTILIDADES ──────────────────────────────────────────────────────────

  formatCurrency(v) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2 }).format(v || 0);
  }
  formatPercentage(v) { return `${(parseFloat(v) || 0).toFixed(2)}%`; }
  formatCPFCNPJ(v) {
    if (!v) return '';
    const n = v.replace(/\D/g, '');
    if (n.length === 11) return n.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    if (n.length === 14) return n.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    return v;
  }
  formatPhone(v) {
    if (!v) return '';
    const n = v.replace(/\D/g, '');
    if (n.length === 11) return n.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    if (n.length === 10) return n.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    return v;
  }
  formatDate(d) { if (!d) return ''; return new Date(d).toLocaleDateString('pt-BR'); }
  up(t, max) { if (!t) return ''; const s = t.toString().toUpperCase(); return max ? s.substring(0, max) : s; }

  processarFormatacaoTexto(texto) {
    return texto
      .replace(/\*\*\*([\s\S]+?)\*\*\*/g, '<strong><em>$1</em></strong>')
      .replace(/^# (.*$)/gm, '<strong>$1</strong><br>')
      .replace(/^## (.*$)/gm, '<strong>$1</strong><br>')
      .replace(/^> (.*$)/gm, '<em>$1</em><br>')
      .replace(/^---$/gm, '<hr>')
      .replace(/\[LEFT\]([\s\S]*?)\[\/LEFT\]/g,    '<span style="display:block;text-align:left;">$1</span>')
      .replace(/\[CENTER\]([\s\S]*?)\[\/CENTER\]/g, '<span style="display:block;text-align:center;">$1</span>')
      .replace(/\[RIGHT\]([\s\S]*?)\[\/RIGHT\]/g,   '<span style="display:block;text-align:right;">$1</span>')
      .replace(/\[JUSTIFY\]([\s\S]*?)\[\/JUSTIFY\]/g,'<span style="display:block;text-align:justify;">$1</span>')
      .replace(/\|\|\|([^|]+?)\|\|\|/g, '<span style="display:block;text-align:center;">$1</span>')
      .replace(/^\u2022 (.*$)/gm, '• $1<br>')
      .replace(/^(\d+)\. (.*$)/gm, '$1. $2<br>')
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/(?<!\*)\*([^*\n]+?)\*(?!\*)/g, '<em>$1</em>')
      .replace(/__(.*?)__/g, '<u>$1</u>')
      .replace(/\^\^\^(.*?)\^\^\^/g, (_, t) => t.toUpperCase())
      .replace(/==(.*?)==/g, '<mark>$1</mark>')
      .replace(/\n\n/g, '<br>').replace(/\n/g, '<br>');
  }

  processarClausulas(clausulas, lote) {
    const cv = parseFloat(lote.comissao?.comissao_venda  || 0);
    const cc = parseFloat(lote.comissao?.comissao_compra || 0);
    const vt = lote.valor_venda_total || 0;
    return this.processarFormatacaoTexto(
      clausulas
        .replace(/%comissao_venda%/g,             `${this.formatPercentage(cv)} — ${this.formatCurrency(vt * cv / 100)}`)
        .replace(/%comissao_compra%/g,            `${this.formatPercentage(cc)} — ${this.formatCurrency(vt * cc / 100)}`)
        .replace(/%valor_total%/g,                this.formatCurrency(vt))
        .replace(/%valor_total_comissao_compra%/g, this.formatCurrency(vt + vt * cc / 100))
        .replace(/%valor_liquido%/g,              this.formatCurrency(vt))
    );
  }

  /**
   * Retorna as parcelas exatamente como foram salvas no faturamento.
   * Array vazio = pagamento à vista. Sem fallbacks.
   * Reutilizável em todos os relatórios.
   */
  getParcelas(lote) {
    return lote.dados_pagamento?.parcelas_calculadas || [];
  }

  // ─── SEÇÕES ──────────────────────────────────────────────────────────────

  secCabecalho(org, leilao, lote) {
    const cidade = leilao.cidade || org.cidade || '';
    const estado = leilao.estado || org.estado || '';
    const local  = [org.nome, this.formatDate(leilao.data_leilao), cidade && estado ? `${cidade}-${estado}` : cidade].filter(Boolean).join(' - ');
    return `
<table class="t-cab">
<tr>
  <td class="cab-logo">
    ${org.logo_url ? `<img src="${org.logo_url}" class="logo">` : `<span class="logo-txt">${this.up(org.nome)}</span>`}
  </td>
  <td class="cab-titulo">
    <div class="cab-t1">CONTRATO DE COMPROMISSO COM RESERVA DE DOMÍNIO E NOTA DE VENDA</div>
    <div class="cab-t2">${this.up(leilao.nome)}</div>
    <div class="cab-t3">${local.toUpperCase()}</div>
  </td>
  <td class="cab-lote">
    <div class="lot-label">CONTRATO LOTE</div>
    <div class="lot-num">${this.up(lote.numero_lote)}</div>
    ${lote.vendedor?.cpf_cnpj  ? `<div class="lot-doc">${this.formatCPFCNPJ(lote.vendedor.cpf_cnpj)}</div>`  : ''}
    ${lote.comprador?.cpf_cnpj ? `<div class="lot-doc">${this.formatCPFCNPJ(lote.comprador.cpf_cnpj)}</div>` : ''}
  </td>
</tr>
</table>`;
  }

  secVendedor(lote) {
    const v = lote.vendedor || {};
    const f = lote.fazenda  || {};
    const end = [v.endereco, v.cidade, v.estado ? (v.cidade ? '/' + v.estado : v.estado) : ''].filter(Boolean).join(' ');
    return `
<table class="t-sec">
<tr><th colspan="2" class="sec-h">DADOS DO VENDEDOR</th></tr>
<tr>
  <td class="dc"><b>Vendedor:</b> ${this.up(v.nome) || '—'}</td>
  <td class="dc"><b>CPF/CNPJ:</b> ${this.formatCPFCNPJ(v.cpf_cnpj) || '—'}</td>
</tr>
<tr>
  <td class="dc" colspan="2"><b>Endereço:</b> ${this.up(end) || '—'}</td>
</tr>
<tr>
  <td class="dc"><b>Fone:</b> ${this.formatPhone(v.telefone) || '—'}</td>
  <td class="dc"><b>E-mail:</b> ${v.email || '—'}</td>
</tr>
<tr>
  <td class="dc"><b>Fazenda:</b> ${this.up(f.nome) || '—'}</td>
  <td class="dc"><b>CNPJ Fazenda:</b> ${this.formatCPFCNPJ(f.cnpj) || '—'}</td>
</tr>
<tr>
  <td class="dc" colspan="2"><b>IE Fazenda:</b> ${f.inscricao_estadual || f.ie || '—'}</td>
</tr>
</table>`;
  }

  secComprador(lote) {
    const c = lote.comprador || {};
    let fd = lote.fazenda_comprador || null;
    if (!fd && lote.fazenda_comprador_id && c.fazendas)
      fd = c.fazendas.find(f => f.id === lote.fazenda_comprador_id) || null;
    fd = fd || {};
    const end = [c.endereco, c.cidade, c.estado ? (c.cidade ? '/' + c.estado : c.estado) : ''].filter(Boolean).join(' ');
    return `
<table class="t-sec">
<tr><th colspan="2" class="sec-h">DADOS DO COMPRADOR</th></tr>
<tr>
  <td class="dc"><b>Comprador:</b> ${this.up(c.nome) || '—'}</td>
  <td class="dc"><b>CPF/CNPJ:</b> ${this.formatCPFCNPJ(c.cpf_cnpj) || '—'}</td>
</tr>
<tr>
  <td class="dc" colspan="2"><b>Endereço:</b> ${this.up(end) || '—'}</td>
</tr>
<tr>
  <td class="dc"><b>Fone:</b> ${this.formatPhone(c.telefone) || '—'}</td>
  <td class="dc"><b>E-mail:</b> ${c.email || '—'}</td>
</tr>
<tr>
  <td class="dc"><b>Propriedade:</b> ${this.up(fd.nome) || '—'}</td>
  <td class="dc"><b>CNPJ Fazenda:</b> ${this.formatCPFCNPJ(fd.cnpj) || '—'}</td>
</tr>
<tr>
  <td class="dc"><b>IE Fazenda:</b> ${fd.inscricao_estadual || fd.ie || '—'}</td>
  <td class="dc"><b>Localidade:</b> ${this.up(fd.cidade) || '—'}</td>
</tr>
</table>`;
  }

  secLote(lote) {
    const sexoLabel = { MACHO: 'MACHOS', FEMEA: 'FÊMEAS', MISTO: 'MISTOS' }[lote.sexo] || this.up(lote.sexo) || '';
    const desc = [lote.qtd, this.up(lote.tipo_animal?.nome), sexoLabel, this.up(lote.idade?.nome), lote.raca?.nome ? this.up(lote.raca.nome) : ''].filter(Boolean).join(' ');
    return `
<table class="t-sec">
<tr><th colspan="2" class="sec-h">ESPECIFICAÇÃO DO LOTE - QUANTIDADE: ${lote.qtd}</th></tr>
<tr>
  <td class="dc" colspan="2" style="font-weight:600;">${desc}</td>
</tr>
${lote.curral || lote.peso ? `<tr>
  <td class="dc"><b>Curral:</b> ${lote.curral || '—'}</td>
  <td class="dc"><b>Peso médio:</b> ${lote.peso ? lote.peso + ' kg' : '—'}</td>
</tr>` : ''}
</table>`;
  }

  secObservacoes(lote) {
    return `
<table class="t-sec">
<tr><th colspan="2" class="sec-h">OBSERVAÇÕES ADICIONAIS</th></tr>
<tr>
  <td class="dc" colspan="2" style="min-height:20px;">${lote.observacoes || '&nbsp;'}</td>
</tr>
</table>`;
  }

  secFinanceiro(lote, config) {
    const parcelas   = this.getParcelas(lote);
    const modalidade = lote.modalidade_pagamento || lote.dados_pagamento?.modalidade_pagamento || 'A_VISTA';
    const vt  = lote.valor_venda_total || 0;
    const cv  = parseFloat(lote.comissao?.comissao_venda  || 0);
    const cc  = parseFloat(lote.comissao?.comissao_compra || 0);
    const dataLeilao = new Date(lote.leilao?.data_leilao || lote.data_faturamento || new Date());

    const calcDias = (d) => Math.max(0, Math.ceil((new Date(d) - dataLeilao) / 86400000));
    const modLabel = modalidade === 'A_VISTA' ? 'À VISTA' : modalidade === 'PRAZO' ? 'PRAZO' : 'PARCELADO';
    const ocultarCC = config.ocultar_comissao_compra;
    let colCount = 7;
    if (!config.mostrar_comissao_venda) colCount--;
    if (ocultarCC) colCount--;

    // Linha de parcelas ou à vista
    let blocoParce = '';
    if (parcelas.length === 0 || modalidade === 'A_VISTA') {
      const dataRef = lote.leilao?.data_leilao || lote.data_faturamento;
      blocoParce = `<tr>
  <td class="dc" colspan="${colCount}">O valor total do presente negócio é de <b>${this.formatCurrency(vt)}</b> a ser pago <b>À VISTA</b>${dataRef ? ` em ${this.formatDate(dataRef)}` : ''}.</td>
</tr>`;
    } else {
      const n = parcelas.length;
      // Distribuição em 3 colunas verticais (como o exemplo)
      const colSz = Math.ceil(n / 3);
      const c1 = parcelas.slice(0, colSz);
      const c2 = parcelas.slice(colSz, colSz * 2);
      const c3 = parcelas.slice(colSz * 2);
      const rows = Math.max(c1.length, c2.length, c3.length);
      const fmtP = (p) => p
        ? `${String(p.numero).padStart(2,'0')}/${n} - ${this.formatCurrency(p.valor)} - ${this.formatDate(p.data)} - ${calcDias(p.data)} DIAS`
        : '';
      let gridRows = '';
      for (let i = 0; i < rows; i++) {
        gridRows += `<tr><td class="pc">${fmtP(c1[i])}</td><td class="pc">${fmtP(c2[i])}</td><td class="pc">${fmtP(c3[i])}</td></tr>`;
      }
      blocoParce = `<tr>
  <td class="dc" colspan="${colCount}">O valor total do presente negócio é de <b>${this.formatCurrency(vt)}</b> que será pago da forma <b>${n} parcela(s)</b> sendo:</td>
</tr>
<tr>
  <td colspan="${colCount}" style="padding:0;">
    <table class="t-parc">${gridRows}</table>
  </td>
</tr>`;
    }

    return `
<table class="t-sec">
<tr><th colspan="${colCount}" class="sec-h">COMPOSIÇÃO DE PREÇO E DADOS FINANCEIROS DO CONTRATO</th></tr>
<tr>
  <th class="fin-h" style="width:22%;">Condições de Pagamento</th>
  <th class="fin-h" style="width:6%;">QTD</th>
  <th class="fin-h" style="width:18%;">Valor do Lote</th>
  ${config.mostrar_comissao_venda ? `<th class="fin-h" style="width:10%;">% Venda</th>` : ''}
  ${!ocultarCC ? `<th class="fin-h" style="width:10%;">% Compra</th>` : ''}
  <th class="fin-h" style="width:12%;">% Comissão</th>
  <th class="fin-h" style="width:14%;">Valor Comissão</th>
</tr>
<tr>
  <td class="dc">${modLabel}</td>
  <td class="dc" style="text-align:center;">${lote.qtd}</td>
  <td class="dc" style="text-align:right;">${this.formatCurrency(vt)}</td>
  ${config.mostrar_comissao_venda ? `<td class="dc" style="text-align:center;">${this.formatPercentage(cv)}</td>` : ''}
  ${!ocultarCC ? `<td class="dc" style="text-align:center;">${this.formatPercentage(cc)}</td>` : ''}
  <td class="dc" style="text-align:center;">${this.formatPercentage(cv + cc)}</td>
  <td class="dc" style="text-align:right;">${this.formatCurrency(vt * (cv + cc) / 100)}</td>
</tr>
${blocoParce}
</table>`;
  }

  secClausulas(html) {
    return `<div class="clausulas-box"><div class="clausulas">${html}</div></div>`;
  }

  secDadosBancarios(lote, org, config) {
    let rows = '';
    if (config.mostrar_dados_bancarios_vendedor && lote.vendedor?.dados_bancarios?.length > 0) {
      const b = lote.vendedor.dados_bancarios.find(x => x.is_principal) || lote.vendedor.dados_bancarios[0];
      rows += `<tr>
  <td class="dc"><b>Banco (Vendedor):</b> ${b.banco || '—'}</td>
  <td class="dc"><b>Agência:</b> ${b.agencia || '—'}   <b>Conta:</b> ${b.conta || '—'}   <b>PIX:</b> ${b.pix || '—'}</td>
</tr>`;
    }
    if (config.mostrar_dados_bancarios_organizador && org?.dados_bancarios?.length > 0) {
      const b = org.dados_bancarios.find(x => x.is_principal) || org.dados_bancarios[0];
      rows += `<tr>
  <td class="dc"><b>Banco (Organizador):</b> ${b.banco || '—'}</td>
  <td class="dc"><b>Agência:</b> ${b.agencia || '—'}   <b>Conta:</b> ${b.conta || '—'}   <b>PIX:</b> ${b.pix || '—'}</td>
</tr>`;
    }
    if (!rows) return '';
    return `<table class="t-sec"><tr><th colspan="2" class="sec-h">DADOS BANCÁRIOS</th></tr>${rows}</table>`;
  }

  secAssinaturas(leilao, lote) {
    const cidade = (leilao.cidade || 'PATOS DE MINAS').toUpperCase();
    const estado = (leilao.estado || 'MG').toUpperCase();
    const data   = this.formatDate(leilao.data_leilao);
    return `
<div class="assin-wrap">
  <div class="assin-row">
    <div class="assin-bloco">
      <div class="assin-linha"></div>
      <div class="assin-nome">${this.up(lote.vendedor?.nome)}</div>
      <div class="assin-cargo">VENDEDOR</div>
    </div>
    <div class="assin-bloco">
      <div class="assin-linha"></div>
      <div class="assin-nome">${this.up(lote.comprador?.nome)}</div>
      <div class="assin-cargo">COMPRADOR</div>
    </div>
  </div>
  <div class="assin-row" style="margin-top:30px;">
    <div class="assin-bloco">
      <div class="assin-linha"></div>
      <div class="assin-cargo">1ª TESTEMUNHA</div>
    </div>
    <div class="assin-bloco">
      <div class="assin-linha"></div>
      <div class="assin-cargo">2ª TESTEMUNHA</div>
    </div>
  </div>
  <div class="assin-data">${cidade}-${estado}, ${data}</div>
</div>`;
  }

  // ─── CSS ─────────────────────────────────────────────────────────────────

  getContratoCSS() {
    return `
@page { size: A4 portrait; margin: 10mm 12mm 12mm 12mm; }
* { margin:0; padding:0; box-sizing:border-box; }
body { font-family: Arial, Helvetica, sans-serif; font-size: 10px; line-height: 1.35; color: #000; background: #fff; }
.pg { width:100%; }

/* ── CABEÇALHO ── */
.t-cab { width:100%; border-collapse:collapse; border:1px solid #000; margin-bottom:3px; }
.t-cab td { vertical-align:middle; }
.cab-logo  { width:18%; padding:6px 8px; text-align:center; border-right:1px solid #000; }
.cab-titulo{ width:64%; padding:6px 10px; text-align:center; border-right:1px solid #000; }
.cab-lote  { width:18%; padding:4px 6px; text-align:center; }
.logo      { max-height:60px; max-width:110px; object-fit:contain; }
.logo-txt  { font-size:10px; font-weight:700; text-transform:uppercase; }
.cab-t1 { font-size:11px; font-weight:700; text-transform:uppercase; line-height:1.25; margin-bottom:3px; }
.cab-t2 { font-size:10px; font-weight:700; margin-bottom:2px; }
.cab-t3 { font-size: 9px; color:#222; }
.lot-label { font-size:8px; font-weight:700; text-transform:uppercase; border-bottom:1px solid #000; padding-bottom:2px; margin-bottom:3px; letter-spacing:0.3px; }
.lot-num   { font-size:24px; font-weight:900; line-height:1; margin-bottom:3px; }
.lot-doc   { font-size:8px; color:#222; line-height:1.4; }

/* ── SEÇÕES ── */
.t-sec { width:100%; border-collapse:collapse; border:1px solid #000; margin-bottom:3px; }
.t-sec td, .t-sec th { border:1px solid #000; }

.sec-h {
  background:#d0d0d0 !important;
  font-size:10px; font-weight:700;
  text-transform:uppercase; text-align:center;
  padding:3px 6px; letter-spacing:0.2px;
  -webkit-print-color-adjust:exact; print-color-adjust:exact;
}

/* célula de dados: label+valor na mesma célula */
.dc { font-size:10px; padding:3px 6px; vertical-align:top; width:50%; }
.dc b { font-weight:700; }

/* ── FINANCEIRO ── */
.fin-h {
  background:#e8e8e8 !important;
  font-size:9px; font-weight:700;
  text-transform:uppercase; text-align:center;
  padding:3px 4px; border:1px solid #000;
  -webkit-print-color-adjust:exact; print-color-adjust:exact;
}

/* ── GRID DE PARCELAS ── */
.t-parc { width:100%; border-collapse:collapse; }
.pc { border:1px solid #000; padding:2px 4px; font-size:9px; font-weight:600; width:33.33%; }

/* ── CLÁUSULAS ── */
.clausulas-box { border:1px solid #000; padding:6px 8px; margin-bottom:3px; }
.clausulas { font-size:9px; line-height:1.5; text-align:justify; text-transform:uppercase; }
.clausulas b    { font-weight:700; }
.clausulas em   { font-style:italic; }
.clausulas u    { text-decoration:underline; }
.clausulas mark { background:#fff176; color:inherit; }
.clausulas hr   { border:none; border-top:1px solid #999; margin:4px 0; }

/* ── ASSINATURAS ── */
.assin-wrap { margin-top:24px; }
.assin-row  { display:flex; justify-content:space-between; gap:50px; }
.assin-bloco{ flex:1; text-align:center; }
.assin-linha{
  width:100%; height:1px;
  background:#000 !important;
  margin-bottom:4px;
  -webkit-print-color-adjust:exact; print-color-adjust:exact;
}
.assin-nome { font-size:10px; font-weight:700; text-transform:uppercase; margin-bottom:1px; }
.assin-cargo{ font-size: 9px; font-weight:700; text-transform:uppercase; color:#333; }
.assin-data { text-align:center; font-size:10px; font-weight:600; margin-top:20px; text-transform:uppercase; }

@media print {
  body { margin:0; padding:0; }
  .sec-h  { background:#d0d0d0 !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
  .fin-h  { background:#e8e8e8 !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
  .assin-linha { background:#000 !important; -webkit-print-color-adjust:exact; print-color-adjust:exact; }
}`;
  }
}

export const contratoService = new ContratoService();

